// componente utilizzata per mostrare la pagina di gestione pannelli; la prima e unica funzione richiamata è la lettura
// dei pannelli mediante apposito servizio di back-end

import { Component, OnInit, Inject } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
export interface DialogData {
  editMode: string;
  id: number;
}
@Component({
  selector: 'mobiletot',
  templateUrl: './mobile.html',
  styleUrls: ['./mobile.component.scss']
})

export class MobileTabComponent implements OnInit {
  constructor(private authService: AuthenticationService, public dialog: MatDialog,) { }
  profile
  groupids = ["Enti", "Gruppi", "Reperibili", "Impianti", "Eccezioni Reperibili", "Codici Allarmi"]
  ngOnInit() {
    this.profile = this.authService.currentUserValue.profile
  }
  logOut() {
    localStorage.clear();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserComplete');
    this.authService.logout();
  }
  settings(setting) {
    switch (setting) {
      case 'Enti': this.dialog.open(Enti, {
        width: '100vw',
      });
        break;
      case 'Gruppi': this.dialog.open(Gruppi, {
        width: '100vw',
      });
        break;
      case 'Reperibili': this.dialog.open(Reperibili, {
        width: '100vw',
      });
        break;
      case 'Impianti': this.dialog.open(Impianti, {
        width: '100vw',
      });
        break;
      case 'Eccezioni Reperibili': this.dialog.open(EccezioniReperibili, {
        width: '100vw',
      });
        break;
      case 'Codici Allarmi': this.dialog.open(CodiciAllarmi, {
        width: '100vw',
      });
        break;
    }
  }

}

// componente per la visualizzazione e gestione della tabella contenente tutti i pannelli (componente destra)
// nella pagina "Pannelli"

import { ViewChild, ChangeDetectorRef, OnDestroy, AfterViewChecked } from '@angular/core';
import { BodyService } from '../view/pages/body/body.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Body } from '../view/pages/body/body.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { UtilsService } from '../service/helper/utils.service';
import { ApiService } from '../service/api.service';
import { NgForm } from '@angular/forms';
import { AlertService } from 'src/app/service/alert.service';
import { BodyListComponent } from '../view/pages/body/body-list/body-list.component';

import { GroupsService } from '../view/pages/groups/groups.service';
import { Groups } from '../view/pages/groups/groups.model';
import { GroupsListComponent } from '../view/pages/groups/groups-list/groups-list.component';

import { PlantsService } from '../view/pages/plants/plants.service';
import { Plants } from '../view/pages/plants/plants.model';
import { PlantsListComponent } from '../view/pages/plants/plants-list/plants-list.component';

import { AvailablesService } from '../view/pages/availables/availables.service';
import { Availables } from '../view/pages/availables/availables.model';
import { AvailablesListComponent } from '../view/pages/availables/availables-list/availables-list.component';

import { AlarmcodesService } from '../view/pages/alarmcodes/alarmcodes.service';
import { Alarmcodes } from '../view/pages/alarmcodes/alarmcodes.model';
import { AlarmcodesListComponent } from '../view/pages/alarmcodes/alarmcodes-list/alarmcodes-list.component';

import { ExceptionsService } from '../view/pages/exceptions/exceptions.service';
import { Exceptions } from '../view/pages/exceptions/exceptions.model';
import { ExceptionsListComponent } from '../view/pages/exceptions/exceptions-list/exceptions-list.component';


@Component({
  selector: 'enti',
  templateUrl: './enti.html',
  styleUrls: ['mobile.component.scss']
})
export class Enti implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;
  dataSource: MatTableDataSource<Body>;
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  displayedColumns: string[] = ['id', 'name', 'tag', 'actions'];
  constructor(private authenticationService: AuthenticationService, private bodyService: BodyService, public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService, private storageService: ApiService) {
  }
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }
  newbody() {
    this.dialog.open(EnteNuovo, {
      width: '100vw',
      data: { editMode: false }
    });
  }
  onEdit(element) {
    this.dialog.open(EnteNuovo, {
      width: '100vw',
      data: { editMode: true, id: parseInt(element.id) }
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit() {
    this.storageService.getBody();



    this.profile = this.authenticationService.currentUserValue.profile


    this.dataSource = new MatTableDataSource(this.bodyService.getBody());
    this.subscription = this.bodyService.bodyChanged.subscribe(
      (bodys: Body[]) => {
        this.dataSource = new MatTableDataSource(bodys);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
      }
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.bodyService.getBody());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }

}
@Component({
  selector: 'nuovoente',
  templateUrl: './nuovoente.html',
  styleUrls: ['mobile.component.scss']
})
export class EnteNuovo implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) bodyForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode
  oldId = 0; // ID del pannello prima della modifica
  editBodyId = 0; // ID del pannello da modificare
  body: Body; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  emailAlredyExist = "";
  bodies = []
  cards = []
  constructor(private als: AlertService, private bodyService: BodyService, private bodyList: BodyListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.bodyForm.value.name)) {
      this.emailAlredyExist = "ID ente già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this
    me.editMode = me.data.editMode
    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v.sort()
    })
    this.dataStorageService.getBodyTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.name)
      })
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    this.bodyid = this.auth.currentUserValue.bodyid

    // si riempie la form coi valori preimpostati
    if (me.data.editMode) {
      me.body = me.bodyService.getBodyByIndex(me.data.id);
      me.oldId = me.body.id
      setTimeout(() => {
        this.bodyForm.setValue({
          name: me.body.name ? me.body.name : "",
          tag: me.body.tag ? me.body.tag : "",
        });
      },);
      me.editBodyId = me.data.id;
      me.editMode = true;
    }
  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    me.utilsService.showLoader();

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxBody().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Body(v,
          value.name,
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeBody(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.body = mess;
        me.bodyService.addBody(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_body = new Body(me.oldId,
        value.name,
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.body = new_body;
      me.body.id = me.editBodyId;
      var res = this.bodyList.getIndex(this.body.id)
      me.bodyService.updateBody(res, me.body);
      me.body.id = me.oldId

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateBody(me.body)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    this.bodyForm.setValue({
      name: '',
      tag: ''
    });
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm("Sei sicuro di voler eliminare l'ente?").subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader();

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteBody(me.body.id)

        // ...il messaggio viene eliminato dalla tabella...
        me.bodyService.deleteBody(me.body.id);

        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;

        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });


  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }

}







@Component({
  templateUrl: 'gruppi.html',
  styleUrls: ['mobile.component.scss']
})
export class Gruppi implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;
  dataSource: MatTableDataSource<Groups>;
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  displayedColumns: string[] = ['groupid', 'description', 'bodyid', 'tag', 'actions'];
  constructor(private authenticationService: AuthenticationService, private groupsService: GroupsService, public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService, private storageService: ApiService) {
  }
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }
  newbody() {
    this.dialog.open(GruppoNuovo, {
      width: '100vw',
      data: { editMode: false }
    });
  }
  onEdit(element) {
    this.dialog.open(GruppoNuovo, {
      width: '100vw',
      data: { editMode: true, id: parseInt(element.id) }
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit() {
    this.storageService.getGroups();
    this.profile = this.authenticationService.currentUserValue.profile
    this.dataSource = new MatTableDataSource(this.groupsService.getGroups());
    this.subscription = this.groupsService.groupsChanged.subscribe(
      (groups: Groups[]) => {
        this.dataSource = new MatTableDataSource(groups);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
      }
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.groupsService.getGroups());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }

}
@Component({
  selector: 'nuovogruppo',
  templateUrl: './nuovogruppo.html',
  styleUrls: ['mobile.component.scss']
})
export class GruppoNuovo implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) groupsForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode
  oldId = 0; // ID del pannello prima della modifica
  editGroupsId = 0; // ID del pannello da modificare
  body: Body; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  emailAlredyExist = "";
  groups
  bodies = []
  cards = []
  constructor(private als: AlertService, private groupsService: GroupsService, private groupsList: GroupsListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.groupsForm.value.name)) {
      this.emailAlredyExist = "ID ente già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this
    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v.sort()
    })
    this.dataStorageService.getGroupsTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.groupid)
      })
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    this.bodyid = this.auth.currentUserValue.bodyid

    // si riempie la form coi valori preimpostati
    if (me.data.editMode) {
        me.groups = me.groupsService.getGroupsByIndex(me.data.id);
        me.oldId = me.groups.id
        if (me.profile == 'SuperAdmin') {
          setTimeout(() => {
          me.groupsForm.setValue({
            groupid: me.groups.groupid ? me.groups.groupid : "",
            description: me.groups.description ? me.groups.description : "",
            bodyid: me.groups.bodyid ? me.groups.bodyid : "",
            tag: me.groups.tag ? me.groups.tag : "",
          });
        },);
        } else {
          setTimeout(() => {
          me.groupsForm.setValue({
            groupid: me.groups.groupid ? me.groups.groupid : "",
            description: me.groups.description ? me.groups.description : "",
            tag: me.groups.tag ? me.groups.tag : "",
          });
        },);
        }

        me.editGroupsId = me.data.id;
        me.editMode = true;
      }
  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var body
    me.profile == 'SuperAdmin' ? body = value.bodyid : body = undefined

    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxGroups().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Groups(v,
          value.groupid,
          value.description,
          body,
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeGroups(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.groups = mess;
        me.groupsService.addGroups(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_groups = new Groups(me.oldId,
        value.groupid,
        value.description,
        body,
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.groups = new_groups;
      me.groups.id = me.editGroupsId;
      var res = this.groupsList.getIndex(this.groups.id)
      me.groupsService.updateGroups(res, me.groups);
      me.groups.id = me.oldId

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateGroups(me.groups)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    var me = this
    if (me.profile == 'SuperAdmin') {
      this.groupsForm.setValue({
        groupid: '',
        description: '',
        bodyid: '',
        tag: ''
      });
    } else {
      this.groupsForm.setValue({
        groupid: '',
        description: '',
        tag: ''
      });
    }
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm('Sei sicuro di voler eliminare il gruppo?').subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteGroups(me.groups.id)

        // ...il messaggio viene eliminato dalla tabella...
        me.groupsService.deleteGroups(me.groups.id);

        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;

        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }

}







@Component({
  templateUrl: 'reperibili.html',
  styleUrls: ['mobile.component.scss']
})
export class Reperibili implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;
  dataSource: MatTableDataSource<Availables>;
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  displayedColumns: string[] = ['lastname', 'firstname', 'telephone', 'bodyid', 'actions'];
  constructor(private authenticationService: AuthenticationService, private bodyService: AvailablesService, public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService, private storageService: ApiService) {
  }
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }
  newbody() {
    this.dialog.open(ReperibileNuovo, {
      width: '100vw',
      data: { editMode: false }
    });
  }
  onEdit(element) {
    this.dialog.open(ReperibileNuovo, {
      width: '100vw',
      data: { editMode: true, id: parseInt(element.id) }
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit() {
    this.storageService.getAvailables();



    this.profile = this.authenticationService.currentUserValue.profile


    this.dataSource = new MatTableDataSource(this.bodyService.getAvailables());
    this.subscription = this.bodyService.availablesChanged.subscribe(
      (bodys: Availables[]) => {
        this.dataSource = new MatTableDataSource(bodys);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
      }
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.bodyService.getAvailables());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }
}
@Component({
  selector: 'nuovoreperibile',
  templateUrl: './nuovoreperibile.html',
  styleUrls: ['mobile.component.scss']
})
export class ReperibileNuovo implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) availablesForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode
  oldId = 0; // ID del pannello prima della modifica
  editAvailablesId = 0; // ID del pannello da modificare
  body: Body; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  emailAlredyExist = "";
  bodies = []
  availables
  profiles
  cards = []
  constructor(private als: AlertService, private availablesService: AvailablesService, private availablesList: AvailablesListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.availablesForm.value.name)) {
      this.emailAlredyExist = "ID ente già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var user = this.auth.user;
    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v.sort()
    })
    this.profile = user.profile
    this.dataStorageService.getAvailablesTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.card)
      })
    })
    if (user.profile == "SuperAdmin") {
      this.profiles = ["Admin", "User", "SuperAdmin"]
    } else if (user.profile == "Admin") {
      this.profiles = ["Admin", "User"]
    }
    var me = this
    if (me.data.editMode)  {
      setTimeout(() => {
        me.availables = me.availablesService.getAvailablesByIndex(me.data.id);
        me.profile == 'SuperAdmin' ? me.availablesForm.setValue({
          firstname: me.availables.firstname ? me.availables.firstname : "",
          lastname: me.availables.lastname ? me.availables.lastname : "",
          password: "",
          card: me.availables.card ? me.availables.card : "",
          email: me.availables.email ? me.availables.email : "",
          telephone: me.availables.telephone ? me.availables.telephone : "",
          profile: me.availables.profile ? me.availables.profile : "",
          enabled: me.availables.enabled ? true : false,
          bodyid: me.availables.bodyid ? me.availables.bodyid : "",
          tag: me.availables.tag ? me.availables.tag : "",
        }) : me.availablesForm.setValue({
          firstname: me.availables.firstname ? me.availables.firstname : "",
          lastname: me.availables.lastname ? me.availables.lastname : "",
          password: "",
          card: me.availables.card ? me.availables.card : "",
          email: me.availables.email ? me.availables.email : "",
          telephone: me.availables.telephone ? me.availables.telephone : "",
          profile: me.availables.profile ? me.availables.profile : "",
          enabled: me.availables.enabled ? true : false,
          tag: me.availables.tag ? me.availables.tag : "",
        }) 
        me.editAvailablesId = me.availablesService.availablesId;
        me.editMode = true;
      }, 100)

    }

  }

  parseStringDate(date) {
    var temp = date.split("/");
    return new Date(temp[2], temp[1] - 1, temp[0])

  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var body
    me.profile == 'SuperAdmin' ? body = value.bodyid : body = undefined
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxAvailables().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Availables(v,
          value.firstname,
          value.lastname,
          value.password,
          value.card,
          value.email,
          value.telephone,
          // "",
          value.profile,
          value.enabled,
          body,
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeAvailables(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.availables = mess;
        me.availablesService.addAvailables(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.dataStorageService.getAvailables();
          me.utilsService.hideLoader();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_availables = new Availables(me.editAvailablesId,
        value.firstname,
        value.lastname,
        "",
        value.card,
        value.email,
        value.telephone,
        // "",
        value.profile,
        value.enabled,
        body,
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.availables = new_availables;
      me.availables.id = me.editAvailablesId;
      var res = this.availablesList.getIndex(this.availables.id)
      me.availablesService.updateAvailables(res, me.availables);

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateAvailables(me.availables)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.dataStorageService.getAvailables();
        me.utilsService.hideLoader();
      }, 1000)
    }
  }
  setDate(date) {
    date = new Date(parseInt(date))
    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
  }
  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    var me = this
    if (!this.editMode) {
      me.profile == 'SuperAdmin' ? me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        bodyid: '',
        tag: ''
      }) : me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        tag: ''
      })
    } else {
      me.profile == 'SuperAdmin' ? me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        bodyid: '',
        tag: ''
      }) : me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        tag: ''
      })
    }
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm('Sei sicuro di voler eliminare il reperibile?').subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteAvailables(me.availables.id)
  
        // ...il messaggio viene eliminato dalla tabella...
        me.availablesService.deleteAvailables(me.availables.id);
  
        // ...viene ripulito la form...
        // me.onClear();
        me.editMode = false;
  
        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }

}







@Component({
  templateUrl: 'impianti.html',
  styleUrls: ['mobile.component.scss']
})
export class Impianti implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;
  dataSource: MatTableDataSource<Plants>;
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  displayedColumns: string[] = ['plantid', 'groupid', 'name', 'bodyid', 'actions'];
  constructor(private authenticationService: AuthenticationService, private bodyService: PlantsService, public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService, private storageService: ApiService) {
  }
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }
  newbody() {
    this.dialog.open(ImpiantoNuovo, {
      width: '100vw',
      data: { editMode: false }
    });
  }
  onEdit(element) {
    this.dialog.open(ImpiantoNuovo, {
      width: '100vw',
      data: { editMode: true, id: parseInt(element.id) }
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit() {
    this.storageService.getPlants();



    this.profile = this.authenticationService.currentUserValue.profile


    this.dataSource = new MatTableDataSource(this.bodyService.getPlants());
    this.subscription = this.bodyService.plantsChanged.subscribe(
      (bodys: Plants[]) => {
        this.dataSource = new MatTableDataSource(bodys);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
      }
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.bodyService.getPlants());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }
}
@Component({
  selector: 'nuovoimpianto',
  templateUrl: './nuovoimpianto.html',
  styleUrls: ['mobile.component.scss']
})
export class ImpiantoNuovo implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) plantsForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode
  oldId = 0; // ID del pannello prima della modifica
  editPlantsId = 0; // ID del pannello da modificare
  body: Body; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  emailAlredyExist = "";
  bodies = []
  groupids = []
  plants
  cards = []
  constructor(private als: AlertService, private plantsService: PlantsService, private plantsList: PlantsListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.plantsForm.value.name)) {
      this.emailAlredyExist = "ID ente già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this
    this.dataStorageService.getPlantsTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.plantid)
      })
    })
    this.dataStorageService.getGroupsList().subscribe(v => {
      this.groupids = v.sort()
      if (me.data.editMode)  {
        setTimeout(() => {
          me.plants = me.plantsService.getPlantsByIndex(me.data.id);
          var groups = []
          if (me.plants.groupid) {
            if (me.plants.groupid.includes('[')) {
              //@ts-ignore
              var temp = me.plants.groupid.substring(1, me.plants.groupid.length-1);
              temp = temp.split(",")
              temp.forEach(t => {
                groups.push(t.replace(" ", ""))
              })
            } else {
              groups.push(me.plants.groupid)
            }
          }
          groups.forEach((t,i) => {
            var el = v.find(a => a.includes(t))
            groups[i] = el
          })
          me.profile == 'SuperAdmin' ? me.plantsForm.setValue({
            plantid: me.plants.plantid ? me.plants.plantid : "",
            groupid: groups,
            alias: me.plants.alias ? me.plants.alias : "",
            name: me.plants.name ? me.plants.name : "",
            address: me.plants.address ? me.plants.address : "",
            latitude: me.plants.latitude ? me.plants.latitude : 0,
            longitude: me.plants.longitude ? me.plants.longitude : 0,
            modem: me.plants.modem ? me.plants.modem : "",
            planttype: me.plants.planttype ? me.plants.planttype : "",
            email: me.plants.email ? me.plants.email : "",
            bodyid: me.plants.bodyid ? me.plants.bodyid : "",
            tag: me.plants.tag ? me.plants.tag : "",
            enabled: me.plants.enabled ? true : false,
          }) : me.plantsForm.setValue({
            plantid: me.plants.plantid ? me.plants.plantid : "",
            groupid: groups,
            alias: me.plants.alias ? me.plants.alias : "",
            name: me.plants.name ? me.plants.name : "",
            address: me.plants.address ? me.plants.address : "",
            latitude: me.plants.latitude ? me.plants.latitude : 0,
            longitude: me.plants.longitude ? me.plants.longitude : 0,
            modem: me.plants.modem ? me.plants.modem : "",
            planttype: me.plants.planttype ? me.plants.planttype : "",
            email: me.plants.email ? me.plants.email : "",
            tag: me.plants.tag ? me.plants.tag : "",
            enabled: me.plants.enabled ? true : false,
          })
          me.editPlantsId = me.plantsService.plantsId;
          me.editMode = true;

        }, 100)

      }
    })

    // // si riempie la form coi valori preimpostati
    // me.subscription = me.plantsService.plantsEditMode.subscribe(
    //   (id: number) => {
    //     me.plants = me.plantsService.getPlantsByIndex(id);
    //     me.oldId = me.plants.id
    //     var groups = []
    //     if (me.plants.groupid) {
    //       //@ts-ignore
    //       me.plants.groupid.includes('[') ? groups = JSON.parse(me.plants.groupid) : groups.push(me.plants.groupid)
    //     }
    //     groups.forEach(v => {
    //       var el = me.groupids.find(a => a.includes(v))
    //       v = el
    //     })
    //     me.plantsForm.setValue({
    //       plantid: me.plants.plantid ? me.plants.plantid : "",
    //       groupid: groups,
    //       alias: me.plants.alias ? me.plants.alias : "",
    //       name: me.plants.name ? me.plants.name : "",
    //       address: me.plants.address ? me.plants.address : "",
    //       latitude: me.plants.latitude ? me.plants.latitude : 0,
    //       longitude: me.plants.longitude ? me.plants.longitude : 0,
    //       modem: me.plants.modem ? me.plants.modem : "",
    //       planttype: me.plants.planttype ? me.plants.planttype : "",
    //       email: me.plants.email ? me.plants.email : "",
    //       bodyid: me.plants.bodyid ? me.plants.bodyid : "",
    //       tag: me.plants.tag ? me.plants.tag : "",
    //     });
    //     me.editPlantsId = id;
    //     me.editMode = true;
    //   }
    // );

    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v.sort()
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    this.bodyid = this.auth.currentUserValue.bodyid

  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var body
    me.profile == 'SuperAdmin' ? body = value.bodyid : body = undefined
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxPlants().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Plants(v,
          value.plantid,
          value.groupid,
          value.alias,
          value.name,
          value.address,
          value.latitude,
          value.longitude,
          value.modem,
          value.planttype,
          value.email,
          body,
          value.tag,
          value.enabled,
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storePlants(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.plants = mess;
        me.plantsService.addPlants(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.dataStorageService.getPlants();
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_plants = new Plants(me.editPlantsId,
        value.plantid,
        value.groupid,
        value.alias,
        value.name,
        value.address,
        value.latitude,
        value.longitude,
        value.modem,
        value.planttype,
        value.email,
        body,
        value.tag,
        value.enabled,
      );

      // si richiamano i servizi di aggiornamento tabella
      me.plants = new_plants;
      me.plants.id = me.editPlantsId;
      var res = this.plantsList.getIndex(this.plants.id)
      me.plantsService.updatePlants(res, me.plants);

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updatePlants(me.plants)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.dataStorageService.getPlants();
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    var me = this
    me.profile == 'SuperAdmin' ? me.plantsForm.setValue({
      plantid: '',
      groupid: '',
      alias: '',
      name: '',
      address: '',
      latitude: 0,
      longitude: 0,
      modem: '',
      planttype: '',
      email: '',
      bodyid: '',
      tag: '',
      enabled: ''
    }) : me.plantsForm.setValue({
      plantid: '',
      groupid: '',
      alias: '',
      name: '',
      address: '',
      latitude: 0,
      longitude: 0,
      modem: '',
      planttype: '',
      email: '',
      tag: '',
      enabled: ''
    })
    me.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm("Sei sicuro di voler eliminare l'impianto?").subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deletePlants(me.plants.id)
  
        // ...il messaggio viene eliminato dalla tabella...
        me.plantsService.deletePlants(me.plants.id);
  
        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;
  
        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }

}







@Component({
  templateUrl: 'eccezioni.html',
  styleUrls: ['mobile.component.scss']
})
export class EccezioniReperibili implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;
  dataSource: MatTableDataSource<Exceptions>;
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  displayedColumns: string[] = ['plantcode', 'alarmcode','availableperson', 'sms', 'actions'];
  constructor(private authenticationService: AuthenticationService, private bodyService: ExceptionsService, public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService, private storageService: ApiService) {
  }
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }
  newbody() {
    this.dialog.open(EccezioneNuovo, {
      width: '100vw',
      data: { editMode: false }
    });
  }
  onEdit(element) {
    this.dialog.open(EccezioneNuovo, {
      width: '100vw',
      data: { editMode: true, id: parseInt(element.id) }
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit() {
    this.storageService.getExceptions();



    this.profile = this.authenticationService.currentUserValue.profile


    this.dataSource = new MatTableDataSource(this.bodyService.getExceptions());
    this.subscription = this.bodyService.exceptionsChanged.subscribe(
      (bodys: Exceptions[]) => {
        this.dataSource = new MatTableDataSource(bodys);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
      }
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.bodyService.getExceptions());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }
}
@Component({
  selector: 'nuovoeccezione',
  templateUrl: './nuovoeccezione.html',
  styleUrls: ['mobile.component.scss']
})
export class EccezioneNuovo implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) exceptionsForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode
  oldId = 0; // ID del pannello prima della modifica
  editExceptionsId = 0; // ID del pannello da modificare
  body: Body; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  emailAlredyExist = "";
  bodies
  plantcodes = []
  availablepersons = []
  alarmcodes = []
  exceptions
  cards = []
  levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  constructor(private als: AlertService, private exceptionsService: ExceptionsService, private exceptionsList: ExceptionsListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.exceptionsForm.value.name)) {
      this.emailAlredyExist = "ID ente già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this

    this.dataStorageService.getPlantsList().subscribe(v => {
      this.plantcodes = v.sort()
    })
    this.dataStorageService.getAvailablesList().subscribe(v => {
      this.availablepersons = v.sort()
    })
    this.dataStorageService.getAlarmcodesList().subscribe(v => {
      this.alarmcodes = v.sort()
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    this.bodyid = this.auth.currentUserValue.bodyid

    // si riempie la form coi valori preimpostati
    if (me.data.editMode)  {
        me.exceptions = me.exceptionsService.getExceptionsByIndex(me.data.id);
        me.oldId = me.exceptions.id
        setTimeout(() => {      

        this.exceptionsForm.setValue({
          plantcode: me.exceptions.plantcode ? me.plantcodes[me.plantcodes.findIndex(element => element.includes(me.exceptions.plantcode))] : "",
          alarmcode: me.exceptions.alarmcode ? me.alarmcodes[me.alarmcodes.findIndex(element => element.includes(me.exceptions.alarmcode))] : "",
          level: me.exceptions.level ? me.exceptions.level : "",
          availableperson: me.exceptions.availableperson ? me.exceptions.availableperson : "",
          voice: me.exceptions.voice ? me.exceptions.voice : false,
          sms: me.exceptions.sms ? me.exceptions.sms : false,
          mail: me.exceptions.mail ? me.exceptions.mail : false,
          tag: me.exceptions.tag ? me.exceptions.tag : "",
        });
      }, 500);
        me.editExceptionsId = me.data.id;
        me.editMode = true;
      }
  }
  first(value) {
    var temp = value.split(" - ")
    return temp[0]
  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxExceptions().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Exceptions(v,
          me.first(value.plantcode),
          me.first(value.alarmcode),
          value.level,
          value.availableperson,
          value.voice,
          value.sms,
          value.mail,
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeExceptions(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.exceptions = mess;
        me.exceptionsService.addExceptions(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_exceptions = new Exceptions(me.oldId,
        me.first(value.plantcode),
        me.first(value.alarmcode),
        value.level,
        value.availableperson,
        value.voice,
        value.sms,
        value.mail,
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.exceptions = new_exceptions;
      me.exceptions.id = me.editExceptionsId;
      var res = this.exceptionsList.getIndex(this.exceptions.id)
      me.exceptionsService.updateExceptions(res, me.exceptions);
      me.exceptions.id = me.oldId

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateExceptions(me.exceptions)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    this.exceptionsForm.setValue({
      plantcode: '',
      alarmcode: '',
      level: '',
      availableperson: '',
      voice: false,
      sms: false,
      mail: false,
      tag: ''
    });
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm("Sei sicuro di voler eliminare l'eccezione?").subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteExceptions(me.exceptions.id)

        // ...il messaggio viene eliminato dalla tabella...
        me.exceptionsService.deleteExceptions(me.exceptions.id);

        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;

        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }

}







@Component({
  templateUrl: 'codici.html',
  styleUrls: ['mobile.component.scss']
})
export class CodiciAllarmi implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;
  dataSource: MatTableDataSource<Alarmcodes>;
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  displayedColumns: string[] = ['code', 'description', 'tts', 'actions'];
  constructor(private authenticationService: AuthenticationService, private bodyService: AlarmcodesService, public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService, private storageService: ApiService) {
  }
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }
  newbody() {
    this.dialog.open(CodiceNuovo, {
      width: '100vw',
      data: { editMode: false }
    });
  }
  onEdit(element) {
    this.dialog.open(CodiceNuovo, {
      width: '100vw',
      data: { editMode: true, id: parseInt(element.id) }
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit() {
    this.storageService.getAlarmcodes();



    this.profile = this.authenticationService.currentUserValue.profile


    this.dataSource = new MatTableDataSource(this.bodyService.getAlarmcodes());
    this.subscription = this.bodyService.alarmcodesChanged.subscribe(
      (bodys: Alarmcodes[]) => {
        this.dataSource = new MatTableDataSource(bodys);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader();
      }
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.bodyService.getAlarmcodes());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }
}
@Component({
  selector: 'nuovocodice',
  templateUrl: './nuovocodice.html',
  styleUrls: ['mobile.component.scss']
})
export class CodiceNuovo implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) alarmcodesForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode
  oldId = 0; // ID del pannello prima della modifica
  editAlarmcodesId = 0; // ID del pannello da modificare
  body: Body; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  emailAlredyExist = "";
  bodies = []
  alarmcodes
  cards = []
  constructor(private als: AlertService, private alarmcodesService: AlarmcodesService, private alarmcodesList: AlarmcodesListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.alarmcodesForm.value.name)) {
      this.emailAlredyExist = "ID ente già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this
    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v.sort()
    })
    this.dataStorageService.getAlarmcodesTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.code)
      })
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile

    // si riempie la form coi valori preimpostati
    if (me.data.editMode)  {
        me.alarmcodes = me.alarmcodesService.getAlarmcodesByIndex(me.data.id);
        me.oldId = me.alarmcodes.id
        setTimeout(() => {
        this.alarmcodesForm.setValue({
          code: me.alarmcodes.code ? me.alarmcodes.code : "",
          description: me.alarmcodes.description ? me.alarmcodes.description : "",
          tts: me.alarmcodes.tts ? me.alarmcodes.tts : "",
          tag: me.alarmcodes.tag ? me.alarmcodes.tag : "",
        });
      },);
        me.editAlarmcodesId = me.data.id;
        me.editMode = true;
      }
  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxAlarmcodes().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Alarmcodes(v,
          value.code,
          value.description,
          value.tts,
          "",
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeAlarmcodes(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.alarmcodes = mess;
        me.alarmcodesService.addAlarmcodes(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_alarmcodes = new Alarmcodes(me.oldId,
        value.code,
        value.description,
        value.tts,
        "",
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.alarmcodes = new_alarmcodes;
      me.alarmcodes.id = me.editAlarmcodesId;
      var res = this.alarmcodesList.getIndex(this.alarmcodes.id)
      me.alarmcodesService.updateAlarmcodes(res, me.alarmcodes);
      me.alarmcodes.id = me.oldId

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateAlarmcodes(me.alarmcodes)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    this.alarmcodesForm.setValue({
      code: '',
      description: '',
      tts: '',
      tag: ''
    });
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm('Sei sicuro di voler eliminare il codice allarme?').subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteAlarmcodes(me.alarmcodes.id)
  
        // ...il messaggio viene eliminato dalla tabella...
        me.alarmcodesService.deleteAlarmcodes(me.alarmcodes.id);
  
        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;
  
        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }
}